import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaCamera, FaCheckCircle, FaEdit, FaEye, FaFileInvoice, FaMedkit, FaNotesMedical, FaRegStickyNote, FaStreetView, FaTable, FaTrash, FaWatchmanMonitoring } from "react-icons/fa";
import { TbDatabaseDollar } from "react-icons/tb";
import { SettingGeneralProvider } from "../../../context/settingGeneralContext";
import TableReusable from "../../Global/Table";
import { FaArrowUpFromGroundWater } from "react-icons/fa6";



export default function TableAppointmentDoctor({
    getData,
    modalDetailPatient,
    page,
    formatToRupiah,
    rows,
    pages,
    changePage,
    msg,
    viewModalUpdate,
    viewModalPaymentType,
    modalDetailDoctor,
    deleteById,
    isTabletOrMobile
}) {
    return (
        <SettingGeneralProvider>
            <TableAppointmentDoctorContent
                getData={getData}
                formatToRupiah={formatToRupiah}
                modalDetailPatient={modalDetailPatient}
                rows={rows}
                page={page}
                pages={pages}
                changePage={changePage}
                msg={msg}
                viewModalUpdate={viewModalUpdate}
                viewModalPaymentType={viewModalPaymentType}
                modalDetailDoctor={modalDetailDoctor}
                deleteById={deleteById}
            />
        </SettingGeneralProvider>
    )
}

function TableAppointmentDoctorContent({
    getData,
    modalDetailPatient,
    rows,
    page,
    pages,
    changePage,
    msg
}) {
    const getRowNumber = (index) => (page - 1) * 10 + index + 1;

    const getCurrentStatus = (row) => {
        const { status, arrangement_data, waiting_data, medical_invoice_data, invoice_data, invoice_paid } = row;

        if (status === 0 || status === null || status === undefined) {
            return "proses_awal";
        }
        if (!arrangement_data || !waiting_data) {
            return "proses_awal";
        }
        if (!medical_invoice_data || !invoice_data) {
            return "treatment_invoice";
        }
        if (invoice_data && !invoice_paid) {
            return "belum_bayar";
        }
        if (invoice_paid) {
            return "selesai";
        }
        return "proses_awal";
    };

    return (
        <div style={{ display: "block", height: "100%", overflowY: "auto", overflowX: "auto" }}>
            {getData.length === 0 ? (
                <div className="text-center py-4">
                    <p style={{ fontSize: "16px", color: "#999" }}>Data tidak tersedia.</p>
                </div>
            ) : (
                <TableReusable
                    columns={[
                        { key: "no", label: "No", render: (_, index) => getRowNumber(index) },
                        { key: "anamnesa", label: "Anamnesa", render: (row) => `${row.anamnesa}` },
                        {
                            key: "pasien",
                            label: "Nama Pasien",
                            render: (row) => (
                                <span style={{ color: 'blue', cursor: 'pointer' }}
                                 onClick={() => { modalDetailPatient(row.patient_data.id) }}
                                 >
                                    {row.patient_name}
                                </span>
                            )
                        },
                        {
                            key: "tanggal", label: "Tanggal",
                            render: (row) => {
                                return (
                                    <>
                                        {row.date.split('-')[2]}&nbsp;
                                        {
                                            row.date.split('-')[1] === "01" ? "Januari" :
                                                row.date.split('-')[1] === "02" ? "Februari" :
                                                    row.date.split('-')[1] === "03" ? "Maret" :
                                                        row.date.split('-')[1] === "04" ? "April" :
                                                            row.date.split('-')[1] === "05" ? "Mei" :
                                                                row.date.split('-')[1] === "06" ? "Juni" :
                                                                    row.date.split('-')[1] === "07" ? "Juli" :
                                                                        row.date.split('-')[1] === "08" ? "Agustus" :
                                                                            row.date.split('-')[1] === "09" ? "September" :
                                                                                row.date.split('-')[1] === "10" ? "Oktober" :
                                                                                    row.date.split('-')[1] === "11" ? "November" :
                                                                                        row.date.split('-')[1] === "12" ? "Desember" : ""
                                        }
                                        &nbsp;{row.date.split('-')[0]}
                                    </>
                                );
                            }
                        },
                        {
                            key: "waktu", label: "Waktu",
                            render: (row) => {
                                return (
                                    <>
                                        <div style={{ display: "flex", justifyContent: "center" }}>
                                            <div
                                                style={{
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                    backgroundColor:
                                                        row?.id_admin === null || row?.id_admin === undefined || row?.id_admin === false
                                                            ? "#C14600"
                                                            : "#FFB450",
                                                    color: "white",
                                                    padding: "0px 5px",
                                                    width: "60px",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                }}

                                            >
                                                {row?.time?.split(":")[0] || "--"} : {row?.time?.split(":")[1] || "--"}
                                            </div>
                                        </div>
                                    </>
                                )
                            }
                        },
                        {
                            key: "status", label: "Status", render: (row) => {
                                const status = getCurrentStatus(row);
                                let labelStatus = "";

                                if (status === "proses_awal") labelStatus = "Appointment Baru";
                                else if (status === "treatment_invoice") labelStatus = "Dalam Proses";
                                else if (status === "belum_bayar") labelStatus = "Belum Bayar";
                                else if (status === "pembayaran") labelStatus = "Sudah Bayar";
                                else if (status === "selesai") labelStatus = "Selesai";

                                return (
                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        <div style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            border: "none",
                                            padding: "0px 7px",
                                            borderRadius: "3px",
                                            backgroundColor:
                                                status === "proses_awal" ? "#ffb450" :
                                                    status === "treatment_invoice" ? "#5ecaff" :
                                                        status === "belum_bayar" ? "#FF6661" :
                                                            status === "pembayaran" ? "#AB00D5" :
                                                                "#96FF86",
                                            color: "white",
                                            fontWeight: "bold",
                                            width: "120px",
                                            textAlign: "center"
                                        }}>
                                            {labelStatus}
                                        </div>
                                    </div>
                                );
                            }
                        },
                    ]}
                    data={getData}
                    rows={rows}
                    page={page}
                    pages={pages}
                    changePage={changePage}
                    msg={msg}
                />
            )}
        </div>
    );

}